import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";

export class LanguageService extends AbstractApiService {
    constructor() {
        super();
    }
    
    public AddMyLanguage(newLanguage: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/language/addmylanguage', newLanguage, onSuccess, onError);
    }

    public DeleteMyLanguage(language: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/language/deletemylanguage', language, onSuccess, onError);
    }

    public GetMyLanguages(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/language/getmylanguages', onSuccess, onError);
    }

    public GetPhysiotherapistsLanguages(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/language/getphysiotherapistslanguages?physiotherapistId=' + physiotherapistId,
            onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/LanguageService.tsx